import styled from 'styled-components';
import PaymentMessage from '../PaymentMessage';

const getColor = ({ mode }) => (mode === 'dark' ? 'white' : 'inherit');

// eslint-disable-next-line import/prefer-default-export
export const StyledPaymentMessage = styled(PaymentMessage)`
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => getColor(theme)}
`;
